export default interface Investment {
  amount: number;
  country: string;
  dateInterest: string;
  description: string;
  productId: string;
  email: string;
  id: string;
  userId:string;
  fullName: string;
  phone: string;
  status: number;
  summary?: string;
  title: string;
  formsField: any[];
  documents: any[];
  subDocsFilled: any[]
}

const investmentInitialValue: Investment = {
  amount: 0,
  country: "",
  dateInterest: "",
  description: "",
  userId: "",
  productId: "",
  email: "",
  id: "",
  fullName: "",
  phone: "",
  status: 0,
  summary: "",
  title: "",
  formsField: [],
  documents: [],
  subDocsFilled: []
};

export { investmentInitialValue };
